import React, { useEffect } from 'react';
import { Input, Checkbox, Button, Divider } from 'antd';
import { useFormDataContext } from '../../../contexts/form-data.ctx';
import Text from 'antd/lib/typography/Text';
import { Box } from '../../../../../components/Box';
import uuid from 'react-uuid';
import { VOTING_VALUES } from '../VotingInput';
import { countries } from '../../../../editor/countries/countries';
import { Option, Select, SelectWithAddItemOption } from '../../../../../components/Input';
import { ConfigProvider, Form } from 'antd';
import moment from 'moment';
import sk_SK from 'antd/lib/locale/sk_SK';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { transformLikvidatorValue, transformProkuristaValue } from '../../../transformers';
import { dots } from '../../../../../utils/constants';
import { RenderSeparatedName } from '../../../../../utils/string';
import { TypInyIdentifikatorEnum } from '../../../../admin/pages/Interfaces';
import { TypInyIdentifikatorEstablishmentTabsEnum } from '../../../../admin/pages/Interfaces';

function PlnomocenstvoHeaderComponent({
  documentId,
  name,
  label = 'Select',
  ...rest
}) {
  const values = useFormDataContext(({ data, setField }) => ({
    konatelia: data['konatelia_establishment_custom'],
    custom: [],
    value: data["plnomocenstvo_establishment_header_custom"] || [],
    setField,
  }));

  const [fieldValues, setFieldValues] = React.useState(values);
  const [value, setValue] = React.useState("");
  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);


  const handleChange = (value) => {
    fieldValues.value = value
    values.setField({
      target: {
        name,
        value: fieldValues.value
      },
    });
    forceUpdate()
  }

  const addItem = (value) => {
    let valuesToSet = fieldValues
    valuesToSet.custom.unshift({ fullName: value, address: "" })
    setFieldValues(valuesToSet)
    forceUpdate()
  };

  return (
    <>
    </>
  );
}

function PlnomocenstvoHeaderHTMLRenderer(values) {
  let returnValue = '';
  if (
    values && values['konatelia_establishment_custom'] && values['konatelia_establishment_custom'].konatelia
  ) {
    returnValue += `Dolu podpísaný klient: `
    let index = 0;
    for (let representingPerson of values['konatelia_establishment_custom'].konatelia) {
      let person = representingPerson
      let tabLength = "&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;"
      returnValue += `${index === 0 ? '&#9;' : tabLength}<b>Meno a priezvisko:</b>&#9;&#9;&#9;&#9;&#9;${person.separatedName ? RenderSeparatedName(person.separatedName) : "[DOPLŇTE]"}<br>`;
      let addressTabLength = "&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;"
      returnValue += `${tabLength}<b>bydlisko:</b>${addressTabLength}`
      returnValue += person.address.street ? person.address.street : "[Doplňte]"
      returnValue += " "
      returnValue += person.address.number ? person.address.number : "[Doplňte]"
      returnValue += ", "
      returnValue += person.address.zip ? person.address.zip : "[Doplňte]"
      returnValue += " "
      returnValue += person.address.city ? person.address.city : "[Doplňte]"
      returnValue += ", "
      returnValue += person.address.country ? countries.sk[person.address.country] : "[Doplňte]"
      returnValue += `<br>`;
      let dobTabLength = "&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;"
      returnValue += `${tabLength}<b>narodený:</b>${dobTabLength}${person.dateOfBirth ? person.dateOfBirth : "[Doplňte]"}`

      let idTabLength = person.idType ? TypInyIdentifikatorEstablishmentTabsEnum[person.idType] : "&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;&#9;"
      returnValue += `<b><br>${tabLength}${person.idType ? TypInyIdentifikatorEnum[person.idType] : "[Doplňte]"}:</b>${idTabLength}${person.idNumber ? person.idNumber : "[Doplňte]"}`

      returnValue += "<br><br>"
      index += 1
    }
  }

  if (returnValue !== '') {
    return returnValue
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Mutator: PlnomocenstvoHeaderComponent,
  HTMLRenderer: PlnomocenstvoHeaderHTMLRenderer,
};
